// DO NOT EDIT -- generated from fs/services/alexa/request_analytics.proto

/** RequestAnalyticsSourceType represents the originating query request source (metric details page, funnel details page, single number dashboard card, etc.) */
export enum RequestAnalyticsSourceType {
  SOURCE_INVALID = 0,
  SEARCHIE_TOP_ERROR_CLICKS = 1,
  SEARCHIE_TOP_RAGE_CLICKS = 2,
  SEARCHIE_TOP_DEAD_CLICKS = 3,
  SEARCHIE_TRAFFIC_BY_REFERER_HOST = 4,
  SEARCHIE_TRAFFIC_BY_UTM_SOURCE = 5,
  SEARCHIE_TRAFFIC_BY_UTM_CAMPAIGN = 6,
  SEARCHIE_TRAFFIC_BY_UTM_MEDIUM = 7,
  SEARCHIE_TRAFFIC_BY_BROWSER = 8,
  SEARCHIE_DEVICE_BREAKDOWN = 9,
  SEARCHIE_EVENT_FUNNEL = 10,
  SEARCHIE_MOST_ACTIVE_USERS = 11,
  SEARCHIE_SEGMENT_HEALTH = 12,
  SEARCHIE_TOP_PAGES = 13,
  SEARCHIE_RAGE_GRADE = 14,
  SEARCHIE_ACTIVITY_SUMMARY = 15,
  SEARCHIE_DAILY_ACTIVES = 16,
  SEARCHIE_MATCHING_USERS = 17,
  SEARCHIE_TIME_RANGE_COUNTS = 18,
  SEARCHIE_FEEDBACK = 19,
  SEARCHIE_SCREEN_RESOLUTIONS = 20,
  SEARCHIE_SLOW_PAGES = 21,
  SEARCHIE_MOBILE_DEVICES = 22,
  SEARCHIE_MOBILE_APP_VERSIONS = 23,
  SEARCHIE_MOBILE_RESOLUTIONS = 24,
  SEARCHIE_MOBILE_OS_VERSIONS = 25,
  SEARCHIE_API_ERRORS = 26,
  SEARCHIE_MOST_COMMON_ENTRY_PAGES = 27,
  SEARCHIE_USER_TRENDS_CARD = 28,
  ASYNC_MATCHING_USERS = 29,
  METRIC_DETAILS = 30,
  FUNNEL_DETAILS = 31,
  HEATMAP_DETAILS = 32,
  JOURNEY_DETAILS = 33,
  RETENTION_DETAILS = 34,
  CONVERSION_ANALYSIS = 35,
  METRIC_DIMENSIONALITY = 36,
  METRIC_SINGLE_NUMBER = 37,
  METRIC_TRENDS = 38
}

/** RequestAnalyticsIdType provide a mapping for relevant id types associated to query cost detail */
export enum RequestAnalyticsIdType {
  INVALID = 0,
  SEGMENT = 1,
  METRIC = 2,
  FUNNEL = 3,
  HEATMAP = 4,
  RETENTION = 5,
  CARD = 6,
  CONVERSION = 7,
  CONVERSION_MAPS = 8,
  PROACTIVE_METRIC = 9,
  PROACTIVE_FUNNEL = 10
}

/** RequestAnalyticsAttributes contains attributes associated for a given query request */
export interface RequestAnalyticsAttributes {
  /** Id is the specified id value for a given query request (segment id, metric id, etc) */
  id: string;
  /** RequestAnalyticsIdType represents the source id type for the given request */
  type: RequestAnalyticsIdType;
  /** Named specifies if the source request id is named/unnamed */
  named: boolean;
}
